var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHryvnia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 448.000000 600.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,600.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1987 5795 c-559 -68 -1058 -338 -1393 -755 -78 -97 -154 -205 -154 -218 0 -8 721 -508 751 -520 4 -2 33 34 65 80 75 107 208 246 308 320 99 74 256 151 361 178 158 41 374 43 520 5 154 -40 309 -146 372 -253 77 -131 84 -309 17 -461 -30 -68 -96 -160 -167 -233 l-55 -58 -1286 0 -1286 0 2 -302 3 -303 974 -5 974 -5 -334 -265 -334 -265 -640 -5 -640 -5 -3 -302 -2 -303 396 -2 396 -3 -36 -47 c-83 -108 -147 -246 -189 -401 -18 -69 -21 -109 -22 -257 0 -161 3 -183 28 -275 139 -503 598 -828 1307 -926 146 -21 547 -18 690 4 593 92 1099 359 1440 762 70 83 150 193 150 206 0 8 -748 515 -774 525 -8 3 -40 -29 -82 -82 -273 -350 -606 -524 -1003 -524 -485 0 -751 187 -751 528 0 170 47 279 177 410 l82 82 1295 0 1296 0 -2 302 -3 303 -988 5 -988 5 328 265 328 265 660 5 660 5 3 303 2 302 -380 0 c-209 0 -380 2 -380 4 0 2 16 27 35 56 77 115 141 281 170 443 24 133 17 356 -15 472 -122 449 -509 774 -1071 899 -243 54 -569 70 -812 41z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHryvnia);
export default __webpack_public_path__ + "static/media/hryvnia.29bd6c780a199066089642a90e1b04a5.svg";
export { ForwardRef as ReactComponent };